import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const BoardOutdentIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.5 2H1.5C1.22386 2 1 2.22386 1 2.5V3.5C1 3.77614 1.22386 4 1.5 4H23.5C23.7761 4 24 3.77614 24 3.5V2.5C24 2.22386 23.7761 2 23.5 2Z"
        fill={color}
      />
      <path
        d="M23.5 20H1.5C1.22386 20 1 20.2239 1 20.5V21.5C1 21.7761 1.22386 22 1.5 22H23.5C23.7761 22 24 21.7761 24 21.5V20.5C24 20.2239 23.7761 20 23.5 20Z"
        fill={color}
      />
      <path
        d="M23.5 8H12.5C12.2239 8 12 8.22386 12 8.5V9.5C12 9.77614 12.2239 10 12.5 10H23.5C23.7761 10 24 9.77614 24 9.5V8.5C24 8.22386 23.7761 8 23.5 8Z"
        fill={color}
      />
      <path
        d="M23.5 14H12.5C12.2239 14 12 14.2239 12 14.5V15.5C12 15.7761 12.2239 16 12.5 16H23.5C23.7761 16 24 15.7761 24 15.5V14.5C24 14.2239 23.7761 14 23.5 14Z"
        fill={color}
      />
      <path
        d="M3.82 15.06V13H8.65C9.2 13 9.65 12.55 9.65 12C9.65 11.45 9.2 11 8.65 11H3.82V8.93999C3.82 8.54999 3.35 8.35999 3.08 8.62999L0.21 11.49C-0.07 11.77 -0.07 12.23 0.21 12.52L3.07 15.38C3.34 15.65 3.81 15.46 3.81 15.07L3.82 15.06Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

BoardOutdentIcon.displayName = 'BoardOutdentIcon';
